import { render, staticRenderFns } from "./EmbargoedDataAgreement.vue?vue&type=template&id=67a430b6&scoped=true"
import script from "./EmbargoedDataAgreement.vue?vue&type=script&lang=js"
export * from "./EmbargoedDataAgreement.vue?vue&type=script&lang=js"
import style0 from "./EmbargoedDataAgreement.vue?vue&type=style&index=0&id=67a430b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a430b6",
  null
  
)

export default component.exports